module.exports = __webpack_public_path__ + "static/media/burger-logo.976da2e3.jpg";